export * from './local.config';
export * from './dev.config';
export * from './qa.config';
export * from './staging.config';
export * from './prod.config';



// WEBPACK FOOTER //
// ./src/app/environment-variables/base/index.ts